"use client"

import { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"

const Timer = ({ time }) => {
  const [step, setStep] = useState(-1)
  const timerRef = useRef(null)

  useEffect(() => {
    setStep(-1)
    doNext()

    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  const doNext = () => {
    if (step + 1 < time) {
      setStep((prev) => prev + 1)
      timerRef.current = setTimeout(doNext, 1000)
    }
  }

  return (
    <div className="countdown">
      <div className="countdown-number">{time - step}</div>
      <svg>
        <circle r="48" cx="50" cy="50" style={{ animationDuration: `${time}s` }} />
      </svg>
    </div>
  )
}

Timer.propTypes = {
  time: PropTypes.number.isRequired,
}

export default Timer
